/* Snabbvyn for upsell-kort. Lag inline i snippets/on-upsell-quickview.liquid
   och vagde 25 927 byte i varje sidvisning. Flyttad hit 2026-10-09, och pa nytt
   2026-10-13 fran snabbfixens version vid sammanslagningen med LIVE (punkt 16).

   Den ar ett custom element, sa den startar om av sig sjalv nar Horizon ritar
   om en del av sidan och vid shopify:section:load.

   De fyra oversatta strangarna kan inte ligga har, for de renderas per sprak.
   De satts i window.__onQvT av en rad inline och las i borjan av koden. */

  (function () {
    if (window.__onQvInit) return;
    var T = window.__onQvT || {};
    window.__onQvInit = true;
    var T_OOS = (T.oos || '');
    var T_ADD = (T.add || '');
    var T_SWIPE = (T.swipe || '');
    var T_MORE = (T.more || '');

    function isColorOpt(name) {
      return /(f[äa]rg|colou?r|farbe|kleur|couleur|colore|kolor|\bcor\b|v[äa]ri|farve)/i.test(name || '');
    }
    function swatchColor(name) {
      var n = (name || '').toLowerCase();
      if (n.indexOf('bambu') > -1 || n.indexOf('bamboo') > -1) return '#39ff14';
      if (/(svart|black|sort|musta|schwarz|zwart|noir|nero|negro|czarn|preto)/.test(n)) return '#111111';
      if (/(vit|white|valk|weiss|weiß|wit|blanc|bianco|blanco|biał|branco)/.test(n)) return '#ffffff';
      if (/(salvi|salbei|salie|sauge|sage|sza[łl]wi|salva)/.test(n)) return '#9caf88';
      if (/(oliv|oliiv|olijf|oliwk|azeitona)/.test(n)) return '#6b6f3a';
      if (/(gr[öo]n|green|gr[øo]n|vihre|grün|groen|vert|verde|ziel)/.test(n)) return '#004E20';
      if (/(m[öo]rk ?bl[åa]|m[øo]rkebl[åa]|tummansinin|dark blue|dunkelblau|donkerblauw|bleu fonc|blu scuro|azul oscuro|ciemnoniebiesk|azul-escuro)/.test(n)) return '#1f3a63';
      if (/(ljus ?bl[åa]|lysebl[åa]|vaaleansinin|light blue|hellblau|lichtblauw|bleu clair|azzurro|azul claro|jasnoniebiesk|azul-claro)/.test(n)) return '#7fa8d8';
      if (/(bl[åa]|blue|sin|blau|blauw|bleu|\bblu\b|azul|niebie)/.test(n)) return '#1f4e79';
      if (/(gr[åa]|grey|gray|harmaa|grau|grijs|gris|grigio|szar|cinz)/.test(n)) return '#808080';
      if (/(beige|sand|khaki|kaki)/.test(n)) return '#c2b280';
      if (/(brun|brown|braun|marron|marrone|marrón|ruskea|bruin|brąz|braz|castanho)/.test(n)) return '#6b4423';
      if (/(r[öo]d|\bred\b|rot|rood|rouge|rosso|rojo|czerw|vermelh)/.test(n)) return '#b22222';
      return null;
    }

    class OnUpsellQuickview extends HTMLElement {
      connectedCallback() {
        if (this.__init) return;
        this.__init = true;
        this.dialog = this.querySelector('[data-qv-dialog]');
        this.badgeEl = this.querySelector('[data-qv-badge]');
        this.nameEl = this.querySelector('[data-qv-name]');
        this.reviewsEl = this.querySelector('[data-qv-reviews]');
        this.priceEl = this.querySelector('[data-qv-price]');
        this.pitchEl = this.querySelector('[data-qv-pitch]');
        this.optsEl = this.querySelector('[data-qv-opts]');
        this.sgEl = this.querySelector('[data-qv-sg]');
        this.msg = this.querySelector('[data-qv-msg]');
        this.addBtn = this.querySelector('[data-qv-add]');
        this.moreEl = this.querySelector('[data-qv-more]');
        this.galEl = this.querySelector('[data-qv-gallery]');
        this.gImg = this.querySelector('[data-qv-gimg]');
        this.gNav = this.querySelector('[data-qv-gnav]');
        this.thumbsEl = this.querySelector('[data-qv-thumbs]');
        this.pbEl = this.querySelector('[data-qv-pb]');
        this.descEl = this.querySelector('[data-qv-desc]');
        this.descBody = this.querySelector('[data-qv-desc-body]');

        var self = this;

        var closeBtn = this.querySelector('[data-qv-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () { self.close(); });
        if (this.dialog) {
          // Klick inne i modalen får ALDRIG bubbla till varukorgs-drawern (som annars stänger
          // sig vid klick "utanför"). Modalen ligger i top-layer ovanpå drawern.
          this.dialog.addEventListener('click', function (e) {
            e.stopPropagation();
            if (e.target === self.dialog) self.close();
          });
          ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
            self.dialog.addEventListener(ev, function (e) { e.stopPropagation(); });
          });
        }

        this.optsEl.addEventListener('click', function (e) {
          var b = e.target.closest('[data-oi]');
          if (!b) return;
          var i = parseInt(b.getAttribute('data-oi'), 10);
          self.selected[i] = b.getAttribute('data-ov');
          Array.prototype.forEach.call(b.parentNode.querySelectorAll('[data-oi]'), function (x) {
            x.classList.toggle('is-active', x === b);
          });
          self.recompute();
        });

        this.addBtn.addEventListener('click', function () { self.add(); });

        // Dam/Herr-växlaren i badgen: byt produkt i modalen istället för att navigera till PDP:n.
        this.badgeEl.addEventListener('click', function (e) {
          var a = e.target.closest('.on-gbadge__link');
          if (!a) return;
          if (self.switchGender(a)) e.preventDefault();
        });

        // Storleksguide-knappen i modalen: dialogen stoppar click-bubbling (så drawern inte stängs),
        // därför når klicket aldrig on-szp:s document-lyssnare. Öppna guiden DIREKT via den globala funktionen.
        this.sgEl.addEventListener('click', function (e) {
          var b = e.target.closest('[data-sizepop]');
          if (!b) return;
          e.preventDefault();
          if (typeof window.__onSzpOpen === 'function') { window.__onSzpOpen(b); }
          else { document.dispatchEvent(new CustomEvent('on-szp-open', { detail: { button: b } })); }
        });

        // Global delegation: alla quickview-triggers (även efter cart-rerender / dynamiska kort).
        if (!window.__onQvClick) {
          window.__onQvClick = true;
          document.addEventListener('click', function (e) {
            var b = e.target.closest('[data-qv-open]');
            if (!b) return;
            e.preventDefault();
            self.openFor(b);
          });
        }
      }

      /* Sprakroten. Utan den hamtades produkten fran butikens standardsprak,
         och beskrivningen under kopknappen stod pa svenska pa alla marknader
         trots att oversattningen fanns i Shopify. */
      rot() {
        var r = this.getAttribute('data-qv-root') || '/';
        /* Inget reguljart uttryck har. Forsta forsoket skrev ett med bakstreck
           genom ett skal som at bakstrecket; kvar blev // mitt i uttrycket,
           alltsa en kommentar, och hela snabbvyns script slutade koras.
           En slice gor samma sak och kan inte ga sonder pa den vagen. */
        while (r.length && r.charAt(r.length - 1) === '/') r = r.slice(0, -1);
        return r;
      }

      close() {
        try { this.dialog.close(); } catch (e) { this.dialog.removeAttribute('open'); }
      }

      fillReviews(node) {
        var lang = node.getAttribute('data-lang') || 'en';
        var count = parseInt(node.getAttribute('data-count') || '0', 10);
        var rating = parseFloat(node.getAttribute('data-rating') || '0');
        if (!rating || rating <= 0) rating = 5;
        var word = node.getAttribute('data-word') || 'reviews';
        var rv = node.querySelector('.on-qvs__rv');
        if (!rv) return;
        var r, c;
        try { r = rating.toLocaleString(lang, { minimumFractionDigits: 1, maximumFractionDigits: 1 }); } catch (e) { r = String(rating).replace('.', ','); }
        try { c = count.toLocaleString(lang); } catch (e) { c = String(count); }
        rv.textContent = r + '/5 • ' + c + ' ' + word;
      }

      // Produktnamnet ska ALLTID rymmas på en rad → krymp textstorleken tills det passar.
      fitName() {
        var el = this.nameEl;
        if (!el) return;
        el.style.fontSize = '';
        var size = 19, guard = 0;
        while (el.scrollWidth > el.clientWidth + 1 && size > 12 && guard < 24) {
          size -= 1; el.style.fontSize = size + 'px'; guard++;
        }
      }

      openFor(btn) {
        /* Oppnas snabbvyn fran ett tillaggskort i paketlage ska kopknappen har
           inne lagga varan i PAKETET, inte i varukorgen. Varden ar kortets
           <on-fbt>, inte dialogen - dialogen ar gemensam for hela sidan. */
        this.bundleHost = btn.closest ? btn.closest('on-fbt[data-bundle="1"]') : null;
        this.bundleCard = btn.closest ? btn.closest('[data-fbt-card]') : null;
        // Bygg en karta över kortets dolda mallar (produkten + ev. köns-motpart), keyad på handle.
        var item = btn.closest('.on-cu__item');
        this.tplMap = {};
        if (item) {
          Array.prototype.forEach.call(item.querySelectorAll('template[data-handle]'), function (t) {
            this.tplMap[t.getAttribute('data-handle')] = t;
          }, this);
        }
        // Öppna först (så det känns snabbt), ladda sedan produkten.
        if (typeof this.dialog.showModal === 'function') {
          try { this.dialog.showModal(); } catch (e) { this.dialog.setAttribute('open', ''); }
        } else { this.dialog.setAttribute('open', ''); }
        this.loadFromTemplate(btn.getAttribute('data-qv-handle'), btn.getAttribute('data-qv-variant'), btn);
      }

      // Fyller modalen från EN mall (produkten eller dess köns-motpart) + hämtar dess varianter.
      loadFromTemplate(handle, presetVariant, btn) {
        var tpl = this.tplMap && this.tplMap[handle];
        /* Utan mall avbrot den har tidigare direkt, och rutan blev staende tom.
           Varukorgens upsell renderar en dold mall per kort; "Kops ofta ihop"
           gor inte det, sa den behover en egen vag. */
        if (!tpl || !tpl.content) { this.loadPlain(handle, presetVariant, btn); return; }
        this.noTpl = false;
        this.handle = handle;
        this.currentId = presetVariant || null;
        this.product = null;
        this.nameEl.textContent = tpl.getAttribute('data-title') || '';
        var selfN = this; requestAnimationFrame(function () { selfN.fitName(); });
        this.badgeEl.innerHTML = '';
        this.reviewsEl.innerHTML = '';
        this.priceEl.innerHTML = '';
        this.pitchEl.innerHTML = '';
        this.sgEl.innerHTML = '';
        this.moreEl.innerHTML = '';
        // Klona i rätt ordning: badge → recensioner → pris → bullets → storleksguide → detaljlänk.
        var frag = tpl.content.cloneNode(true);
        // Översättningskarta för variantvärden (optionsnamn + värden per språk).
        this.i18n = null;
        var i18nEl = frag.querySelector('.on-qvs__i18n');
        if (i18nEl) { try { this.i18n = JSON.parse(i18nEl.textContent); } catch (e) { this.i18n = null; } }
        var badge = frag.querySelector('.on-qvs__badge');
        var reviews = frag.querySelector('.on-qvs__reviews');
        var price = frag.querySelector('.on-qvs__price');
        var pitch = frag.querySelector('.on-qvs__pitch');
        var sg = frag.querySelector('.on-qvs__sg');
        var more = frag.querySelector('.on-qvs__more');
        if (badge && badge.innerHTML.trim()) this.badgeEl.appendChild(badge);
        if (reviews) { this.reviewsEl.appendChild(reviews); this.fillReviews(reviews); }
        if (price) this.priceEl.appendChild(price);
        if (pitch && pitch.innerHTML.trim()) this.pitchEl.appendChild(pitch);
        if (sg && sg.querySelector('[data-sizepop]')) this.sgEl.appendChild(sg);
        if (more) this.moreEl.appendChild(more);
        this.optsEl.innerHTML = '<div class="on-qv__loading">…</div>';
        this.addBtn.disabled = true;
        this.addBtn.textContent = T_ADD;
        this.msg.hidden = true;
        var self = this;
        fetch(this.rot() + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) { if (self.handle === handle) { self.product = p; self.build(p); } })
          .catch(function () { self.optsEl.innerHTML = ''; self.recompute(); });
      }

      /* Reservväg: bygger rutan utan dold mall. Namn, detaljlänk och pris
         kommer från knappen som öppnade den — priset som FÄRDIG markup från
         Liquid, inte formaterat i JS. Temat har en uttrycklig regel mot att
         gissa prisformat ur shop.money_format, och marknaderna skiljer sig åt
         i både symbol, placering och avgränsare. */
      loadPlain(handle, presetVariant, btn) {
        this.noTpl = true;
        this.handle = handle;
        this.currentId = presetVariant || null;
        this.product = null;
        this.i18n = null;
        this.plainPrice = (btn && btn.getAttribute('data-qv-price')) || '';
        this.plainCents = parseInt((btn && btn.getAttribute('data-qv-price-cents')) || '0', 10);
        this.nameEl.textContent = (btn && btn.getAttribute('data-qv-title')) || '';
        var selfN = this; requestAnimationFrame(function () { selfN.fitName(); });
        this.badgeEl.innerHTML = '';
        this.reviewsEl.innerHTML = '';
        this.pitchEl.innerHTML = '';
        this.sgEl.innerHTML = '';
        this.moreEl.innerHTML = '';
        this.priceEl.innerHTML = this.plainPrice ? '<div class="on-qvs__price">' + this.plainPrice + '</div>' : '';
        /* Storleksguiden renderas av Liquid med produktens metafalt och gar
           inte att bygga ur product.js. Kortet har redan en fardig knapp (dold
           i rent lage), sa den klonas hit. Lyssnaren ar delegerad pa document
           via closest('[data-sizepop]'), darfor fungerar en klon. */
        var kort = btn && btn.closest ? btn.closest('.on-fbt__card') : null;
        var sgBtn = kort ? kort.querySelector('[data-sizepop]') : null;
        if (sgBtn) this.sgEl.appendChild(sgBtn.cloneNode(true));
        /* Produktpunkterna av samma skal som storleksguiden: de bor i ett
           metafalt och finns inte i product.js. */
        if (this.pbEl) {
          this.pbEl.innerHTML = '';
          var specSrc = kort ? kort.querySelector('template.on-fbt__specsrc') : null;
          this.specsHtml = (specSrc && specSrc.innerHTML) ? specSrc.innerHTML : '';
          var pbSrc = kort ? kort.querySelector('template.on-fbt__pbsrc') : null;
          if (pbSrc && pbSrc.content) {
            this.pbEl.appendChild(pbSrc.content.cloneNode(true));
            /* Antalet styrs fran temainstallningen. Kapas i JS och inte med
               nth-child, eftersom granssiffran kommer fran Liquid och en
               CSS-regel inte kan ta emot den som variabel. */
            var maxPb = parseInt(this.getAttribute('data-qv-pb-max') || '4', 10);
            if (maxPb > 0) {
              var poster = this.pbEl.querySelectorAll('.on-pb__item');
              for (var pi = maxPb; pi < poster.length; pi++) poster[pi].remove();
            }
          }
        }
        var url = btn && btn.getAttribute('data-qv-url');
        if (url) {
          var a = document.createElement('a');
          a.className = 'on-qvs__more';
          a.href = url;
          a.textContent = T_MORE;
          this.moreEl.appendChild(a);
        }
        this.optsEl.innerHTML = '<div class="on-qv__loading">…</div>';
        this.addBtn.disabled = true;
        this.addBtn.textContent = T_ADD;
        this.msg.hidden = true;
        var self = this;
        fetch(this.rot() + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (p) { if (self.handle === handle) { self.product = p; self.build(p); } })
          .catch(function () { self.optsEl.innerHTML = ''; self.recompute(); });
      }

      // Dam/Herr-växlaren: byt produkt IN-PLACE (ingen navigering ur varukorgen) om motparten
      // finns i kortets mallar. Annars låt länken navigera som vanligt (PDP-beteende).
      switchGender(link) {
        var href = link.getAttribute('href') || '';
        var m = href.match(/\/products\/([^/?#]+)/);
        var h = m ? m[1] : null;
        if (h && this.tplMap && this.tplMap[h]) { this.loadFromTemplate(h); return true; }
        return false;
      }

      build(product) {
        this.optsEl.innerHTML = '';
        var names = product.options.map(function (o) { return (typeof o === 'string') ? o : o.name; });
        var single = names.length === 1 && (names[0] === 'Title' || product.variants.length === 1);
        var values = names.map(function () { return []; });
        product.variants.forEach(function (v) {
          v.options.forEach(function (val, i) { if (values[i].indexOf(val) < 0) values[i].push(val); });
        });
        var cur = product.variants.filter(function (v) { return String(v.id) === String(this.currentId); }, this)[0]
          || product.variants.filter(function (v) { return v.available; })[0]
          || product.variants[0];
        this.selected = cur.options.slice();
        var self = this;
        var i18n = this.i18n;
        function tval(i, val) { return (i18n && i18n.values && i18n.values[i] && i18n.values[i][val]) || val; }
        if (!single) {
          names.forEach(function (name, i) {
            var group = document.createElement('div'); group.className = 'on-qv__group';
            var glabel = (i18n && i18n.names && i18n.names[i]) || name;
            var lab = document.createElement('div'); lab.className = 'on-qv__glabel'; lab.textContent = glabel; group.appendChild(lab);
            var row = document.createElement('div'); row.className = 'on-qv__row';
            var color = isColorOpt(name);
            if (color) row.className = 'on-qv__row on-qv__row--img';
            values[i].forEach(function (val) {
              var b = document.createElement('button');
              b.type = 'button';
              b.setAttribute('data-oi', i);
              b.setAttribute('data-ov', val);
              if (color) {
                // Färg = produktBILD (så kunden ser plagget utan att lämna varukorgen), horisontell scroll.
                b.className = 'on-qv__opt on-qv__opt--img';
                var vv = product.variants.filter(function (v) { return v.options[i] === val; })[0];
                var src = (vv && vv.featured_image && vv.featured_image.src) || product.featured_image || (product.images && product.images[0]) || '';
                var disp = tval(i, val);
                if (src) {
                  var sized = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=220';
                  var img = document.createElement('img');
                  img.className = 'on-qv__opt-img'; img.src = sized; img.alt = disp; img.loading = 'lazy';
                  b.appendChild(img);
                }
                var cap = document.createElement('span'); cap.className = 'on-qv__opt-cap'; cap.textContent = disp;
                b.appendChild(cap);
              } else {
                b.className = 'on-qv__opt';
                b.textContent = tval(i, val);
              }
              if (self.selected[i] === val) b.classList.add('is-active');
              row.appendChild(b);
            });
            group.appendChild(row);
            if (color && values[i].length > 2) {
              var hint = document.createElement('div'); hint.className = 'on-qv__swipe';
              hint.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 7l-5 5 5 5M16 7l5 5-5 5"/></svg><span>' + T_SWIPE + '</span>';
              group.appendChild(hint);
            }
            self.optsEl.appendChild(group);
          });
        }
        this.buildGallery(product);
        this.buildDesc(product);
        this.recompute();
      }

      /* Galleriet. product.media har bade bilder och video; bara bilder tas med,
         en video utan spelare hade bara blivit en frusen ruta. product.images
         ar reserv for aldre svar. */
      buildGallery(product) {
        if (!this.galEl) return;
        var bilder = [];
        if (product.media && product.media.length) {
          product.media.forEach(function (m) {
            if (m.media_type === 'image' && m.src) bilder.push(m.src);
          });
        }
        if (!bilder.length && product.images && product.images.length) bilder = product.images.slice();
        this.gimgs = bilder;
        this.gidx = 0;
        if (!bilder.length) { this.galEl.hidden = true; return; }
        this.galEl.hidden = false;
        this.gImg.alt = product.title || '';
        this.thumbsEl.innerHTML = '';
        if (bilder.length > 1) {
          var selfT = this;
          bilder.forEach(function (src, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'on-qv__thumb';
            b.setAttribute('aria-label', String(i + 1));
            var im = document.createElement('img');
            im.src = src; im.alt = ''; im.loading = 'lazy';
            b.appendChild(im);
            b.addEventListener('click', function () { selfT.showImg(i); });
            selfT.thumbsEl.appendChild(b);
          });
          this.thumbsEl.hidden = false;
        } else {
          this.thumbsEl.hidden = true;
        }
        this.showImg(0);
      }

      showImg(i) {
        if (!this.gimgs || !this.gimgs.length) return;
        var n = this.gimgs.length;
        this.gidx = ((i % n) + n) % n;
        this.gImg.src = this.gimgs[this.gidx];
        if (this.thumbsEl) {
          var tb = this.thumbsEl.children;
          for (var t = 0; t < tb.length; t++) {
            var akt = t === this.gidx;
            tb[t].classList.toggle('is-active', akt);
            /* Vald miniatyr ska synas aven langt in i en lang rad. */
            if (akt && tb[t].scrollIntoView) tb[t].scrollIntoView({ block: 'nearest', inline: 'nearest' });
          }
        }
      }

      buildDesc(product) {
        if (!this.descEl) return;
        var d = (product.description || '').trim();
        var spec = this.specsHtml || '';
        /* Specifikationerna hor till beskrivningen, precis som i produktsidans
           flik. Finns bara den ena ska rutan anda visas - en produkt kan ha
           specifikationer utan brodtext och tvartom. */
        if (!d && !spec) { this.descEl.hidden = true; this.descBody.innerHTML = ''; return; }
        this.descEl.hidden = false;
        this.descEl.open = false;
        this.descBody.innerHTML = d + (spec ? '<div class="on-qv__specs">' + spec + '</div>' : '');
      }

      recompute() {
        var product = this.product;
        if (!product) { this.addBtn.disabled = true; return; }
        var target = null;
        for (var k = 0; k < product.variants.length; k++) {
          var v = product.variants[k], ok = true;
          for (var i = 0; i < this.selected.length; i++) {
            if (v.options[i] !== this.selected[i]) { ok = false; break; }
          }
          if (ok) { target = v; break; }
        }
        this.target = target;
        /* Priset kom fardigformaterat fran kortets variant. Valjer kunden en
           variant med ANNAT pris vore den siffran fel, och vi kan inte
           formatera om den utan att gissa marknadens format. Da tas den bort
           hellre an visas felaktig. */
        if (this.noTpl && this.plainPrice) {
          if (target && this.plainCents && target.price !== this.plainCents) {
            this.priceEl.innerHTML = '';
          } else {
            this.priceEl.innerHTML = '<div class="on-qvs__price">' + this.plainPrice + '</div>';
          }
        }
        /* Byter kunden farg ska galleriet folja med. Variantens egen bild
           finns i listan; hittas den inte lamnas galleriet som det ar hellre
           an att hoppa till bild 1. */
        if (target && target.featured_image && target.featured_image.src && this.gimgs && this.gimgs.length) {
          var vsrc = String(target.featured_image.src).split('?')[0];
          for (var gi = 0; gi < this.gimgs.length; gi++) {
            if (String(this.gimgs[gi]).split('?')[0] === vsrc) { this.showImg(gi); break; }
          }
        }
        var avail = target && target.available;
        if (target && !avail) { this.msg.hidden = false; this.msg.textContent = T_OOS; }
        else { this.msg.hidden = true; }
        this.addBtn.disabled = !avail;
      }

      add() {
        if (this.addBtn.disabled || !this.target) return;
        if (this.bundleHost) {
          /* Kortet ska peka pa den variant kunden faktiskt valde har inne, annars
             hamnar bocken pa fel varde och andra trycket lagger till en till i
             stallet for att ta bort. */
          var kb = this.bundleCard && this.bundleCard.querySelector('[data-fbt-add]');
          if (kb) kb.setAttribute('data-variant', this.target.id);
          document.dispatchEvent(new CustomEvent('on-vp:addon', {
            bubbles: true, detail: { id: this.target.id, price: this.target.price }
          }));
          this.close();
          return;
        }
        this.addBtn.disabled = true;
        var self = this;
        var cic = document.querySelector('cart-items-component');
        var sid = cic ? (cic.getAttribute('section-id') || cic.getAttribute('data-section-id')) : null;
        var body = { items: [{ id: parseInt(this.target.id, 10), quantity: 1 }] };
        if (sid) { body.sections = sid; body.sections_url = window.location.pathname; }
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (added) {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: { resource: cart, sourceId: 'on-upsell-quickview', data: { source: 'on-upsell-quickview', itemCount: cart.item_count, sections: added ? added.sections : null } }
                }));
                self.close();
              });
          })
          .catch(function () { self.addBtn.disabled = false; });
      }
    }
    customElements.define('on-upsell-quickview', OnUpsellQuickview);
  })();
